import { type ReactiveFormHostMode, ReactiveFormHostState } from './reactive-form-host-state';

export interface ReactiveFormHostUndoStateOptions<TModel> {
    readonly state: ReactiveFormHostState<TModel>;
    readonly enabledModes?: readonly ReactiveFormHostMode[] | undefined;
    readonly explicitValue?: boolean | undefined;
}

const defaultEnabledModes: readonly ReactiveFormHostMode[] = [];

/** Resolves host undo availability while the app keeps the actual undo action. */
export class ReactiveFormHostUndoState {
    public static resolve<TModel>(options: ReactiveFormHostUndoStateOptions<TModel>): boolean {
        const undoEnabled = options.explicitValue ?? (options.enabledModes ?? defaultEnabledModes).includes(options.state.mode);

        options.state.setUndoEnabled(undoEnabled);
        return undoEnabled;
    }

    public static disable<TModel>(state: ReactiveFormHostState<TModel>): boolean {
        state.setUndoEnabled(false);
        return false;
    }
}
